import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'

/**
 * Gates the quarterly tax estimate breakdown improvements to the multi-state
 * calculation rollout cohort. Defaults to false so an environment without the
 * flag configured renders the pre-existing breakdown pages unchanged.
 */
export const useBreakdownTransparency = (): boolean =>
  useBooleanFlagValue(FEATURE_FLAG_KEYS.qteMultiStateCalc, false)
